export default __webpack_public_path__ + "static/media/activity-diet-icon.38a13b05.svg";